import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./GRN.module.css";
import {
  Box,
  Button,
  Fade,
  Modal,
  TextField,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import { useEffect } from "react";

const GRNDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const loginData = useSelector((state) => state.loginData.value);
  const role = loginData?.user?.designation;

  const [itemTab, setItemTab] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [actionLoading, setActionLoading] = useState("");
  const [open, setOpen] = useState(false);

  /* =============================
     SPLIT ACTIVE & COMPLETED
  ============================== */
  const activeItems = state.items.filter(
    (i) => Number(i.quantity_ordered) !== Number(i.quantity_received),
  );

  const completedItems = state.items.filter(
    (i) => Number(i.quantity_ordered) === Number(i.quantity_received),
  );

  const itemsToShow = itemTab === 0 ? activeItems : completedItems;

  /* =============================
        APPROVAL LOGIC
  ============================== */

  const approvalStorageKey = `grn_approval_${state?.grn_number}_${loginData?.user?.token}`;

  const [localApprovals, setLocalApprovals] = useState(() => {
    const serverApprovals = state?.approvals || [];
    const persistedRaw = localStorage.getItem(approvalStorageKey);
    const persisted = persistedRaw ? JSON.parse(persistedRaw) : [];

    const merged = [...serverApprovals];
    persisted.forEach((item) => {
      if (!merged.some((a) => a.approval_level === item.approval_level)) {
        merged.push(item);
      }
    });
    return merged;
  });

  useEffect(() => {
    localStorage.setItem(approvalStorageKey, JSON.stringify(localApprovals));
  }, [localApprovals]);

  if (!state) return <p>No GRN Found</p>;

  const myApprovalLevel =
    role === "Store Executive" ? 1 : role === "Store Manager" ? 2 : null;

  const currentUserApproval = localApprovals.find(
    (a) => a.approval_level === myApprovalLevel,
  );

  const alreadyActionTaken = !!currentUserApproval;
  const currentUserStatus = currentUserApproval?.status;

  const anyRejected = localApprovals.some((a) => a.status === "rejected");

  const level1Approved = localApprovals.some(
    (a) => a.approval_level === 1 && a.status === "approved",
  );

  const level2Approved = localApprovals.some(
    (a) => a.approval_level === 2 && a.status === "approved",
  );

  const effectiveOverallStatus = anyRejected
    ? "rejected"
    : level1Approved && level2Approved
      ? "approved"
      : "pending";

  const canStoreExecutiveAct =
    role === "Store Executive" &&
    !alreadyActionTaken &&
    effectiveOverallStatus === "pending";

  const canStoreManagerAct =
    role === "Store Manager" &&
    level1Approved &&
    !alreadyActionTaken &&
    effectiveOverallStatus === "pending";

  const canTakeAction = canStoreExecutiveAct || canStoreManagerAct;
  const showWaitingForStoreExecutive =
    role === "Store Manager" &&
    !level1Approved &&
    !alreadyActionTaken &&
    effectiveOverallStatus === "pending";

  const isCommentValid = remarks.trim().length > 0;

  const handleApproval = async (status) => {
    if (!remarks.trim()) return;

    try {
      setActionLoading(status);

      await axios.post(API_ENDPOINT.approve_grn, {
        grn_number: state.grn_number,
        approver_token: loginData?.user?.token,
        status,
        remarks,
      });

      const updatedApproval = {
        approval_level: myApprovalLevel,
        status,
        approved_by: loginData?.user?.first_name,
      };

      setLocalApprovals((prev) => {
        const rest = prev.filter((a) => a.approval_level !== myApprovalLevel);
        return [...rest, updatedApproval];
      });

      setRemarks("");

      if (status === "approved" && role === "Store Manager") {
        setOpen(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setActionLoading("");
    }
  };

  /* =============================
          UI
  ============================== */

  return (
    <div className={classes.grncontainer}>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "#007bff",
            color: "white",
            width: "100px",
            border: "none",
            padding: "10px",
            borderRadius: "5px",
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          Back
        </button>
      </Box>

      <Typography variant="h4">GRN Details</Typography>

      {/* ================= TABS ================= */}
      <Box sx={{ mt: 3 }}>
        <Tabs value={itemTab} onChange={(e, v) => setItemTab(v)}>
          <Tab
            label={`Open GRN (${activeItems.length})`}
            sx={{
              fontSize: "14px",
              // textTransform: "none",
              fontFamily: "gilroyBold",
              letterSpacing: "normal",
              // fontWeight: "bold",
            }}
          />
          <Tab
            label={`Closed GRN (${completedItems.length})`}
            sx={{
              fontSize: "14px",
              // textTransform: "none",
              letterSpacing: "normal",
              // fontWeight: "bold",
              fontFamily: "gilroyBold",
            }}
          />
        </Tabs>
      </Box>

      {/* ================= TABLE ================= */}
      <table className={classes.potable}>
        <thead>
          <tr>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Item name
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Description
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Ordered Quantity
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Received Quantity
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Unit Price
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
              Total Price
            </th>
            <th style={{ fontFamily: "gilroyBold", fontSize: "14px" }}>
               Exception Remarks
            </th>
          </tr>
        </thead>

        <tbody>
          {itemsToShow.length > 0 ? (
            itemsToShow.map((item, idx) => (
              <tr key={idx}>
                <td>{item.item_name}</td>

                <td>{item.description}</td>
                <td>{item.quantity_ordered}</td>
                <td>{item.quantity_received}</td>
                <td>₹{Number(item.unit_price || 0).toLocaleString("en-IN")}</td>

                <td>
                  ₹{Number(item.total_price || 0).toLocaleString("en-IN")}
                </td>
                <td>{item.remarks}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No items available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ================= APPROVAL SECTION ================= */}
      {canTakeAction && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" sx={{ padding: "5px", fontWeight: "bold" }}>
            Comments
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Enter your comments..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            sx={{
              "& .MuiInputBase-input": {
                fontSize: "16px", // 🔥 increase font size here
              },
            }}
          />
        </Box>
      )}

      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
        {showWaitingForStoreExecutive && (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                padding: "8px 14px",
                borderRadius: "6px",
                backgroundColor: "#fff3cd",
                color: "#856404",
                border: "1px solid #ffeeba",
              }}
            >
              Waiting for Store Executive Approval
            </Typography>
          </Box>
        )}

        {canTakeAction && (
          <>
            <Button
              size="small"
              variant="contained"
              sx={{ minWidth: 90, fontSize: "12px" }}
              color="success"
              disabled={!isCommentValid || !!actionLoading}
              onClick={() => handleApproval("approved")}
            >
              {" "}
              {actionLoading === "approved" ? "Processing..." : "Approve"}{" "}
            </Button>

            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ minWidth: 90, fontSize: "12px" }}
              disabled={!isCommentValid || !!actionLoading}
              onClick={() => handleApproval("rejected")}
            >
              {" "}
              {actionLoading === "rejected" ? "Processing..." : "Reject"}{" "}
            </Button>

            <Button
              size="small"
              variant="outlined"
              sx={{ minWidth: 90, fontSize: "12px" }}
              onClick={() => navigate(-1)}
            >
              {" "}
              Cancel{" "}
            </Button>
          </>
        )}

        {alreadyActionTaken && (
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            {" "}
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                padding: "8px 22px",
                borderRadius: "6px",
                backgroundColor:
                  currentUserStatus === "approved" ? "#1faa00" : "#d32f2f",
                color: "#fff",
              }}
            >
              {" "}
              {currentUserStatus === "approved" ? "Approved" : "Rejected"}{" "}
            </Typography>{" "}
          </Box>
        )}
      </Box>

      {/* ================= SUCCESS MODAL ================= */}
      <Modal open={open}>
        <Fade in={open}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText="Three Way Matching Generated"
              popupDescription="GRN fully approved and moved to 3-Way Matching process."
              popBtn
              vendorBtn
              btnText="Okay"
              btnClick={() => {
                setOpen(false);
                navigate(-1);
              }}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default GRNDetails;
